/**
 * `text` → **Settings** (spec M1-B5 §6.2, card P-123).
 *
 * `text` is the type monday configures **least**: its `Settings` submenu, captured in full
 * (`discovery/ui-reference/editors/text/settings-dialog.json`), carries *Edit column description*,
 * *Set column as required*, *Set column validation*, *Restrict column editing*, *Restrict column
 * view* and *Save column as a template* — six rows that are all board or permission surfaces, and
 * **no** *Customize Text column*. `textSettingsSchema` agrees: `hide_footer` is the only key
 * `settings_str` carries `[09§A.7]`.
 *
 * So the dialog is monday's one type-owned setting and nothing invented around it (CLAUDE.md
 * rule 3). Per-type "format options" are raised as q518.
 */
import type { TextSettings } from '@elizmonday/shared';
import { HideSummaryField, SettingsForm, useSettingsDraft } from '../settings-kit';
import type { ColumnSettingsProps } from '../types';

export function TextSettingsDialog({ settings, onCommit, onCancel }: ColumnSettingsProps<TextSettings>) {
  const [draft, patch] = useSettingsDraft<TextSettings>(settings);
  return (
    <SettingsForm
      title="Text column settings"
      testId="text-settings"
      onSave={() => onCommit(draft)}
      onCancel={onCancel}
    >
      <HideSummaryField
        divider={false}
        testId="text-hide-footer"
        checked={draft.hide_footer ?? false}
        onChange={(next) => patch({ hide_footer: next })}
      />
    </SettingsForm>
  );
}
